export const mockUser = {
  UserId: 0,
  MerchantId: 0,
  Username: "",
  EmployeeId: "",
  Pin: 0,
  Email: "",
  Telephone: "",
  Roles: [],
  StripeAccountId: "",
  StripeAccountStatus: "not_connected", // not_connected | pending | active | restricted | disabled
  TipPayoutEnabled: false,
  ReceivesHourlyWage: false,
  HourlyRate: null,
  IncludeTipsAndGratuityInPayroll: null,
}